var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contenedor-tabla-pagos"},[_c('table',[_vm._m(0),_c('tbody',_vm._l((_vm.historialDePagos),function(pago){return _c('HistorialPagoListaItem',{key:pago.servicio_id,attrs:{"pago":pago}})}),1)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('thead',[_c('th',[_vm._v("Fecha")]),_c('th',[_vm._v("Concepto")]),_c('th',[_vm._v("Monto")])])
}]

export { render, staticRenderFns }